import {
    HomeOutlined,
    TeamOutlined,
    BookOutlined,
    UsergroupAddOutlined,
    FileDoneOutlined,
    DollarOutlined,
    SnippetsOutlined,
    StarOutlined,
    FileTextOutlined,
    TrophyOutlined,
    BankOutlined
} from "@ant-design/icons";

const SUPER_ADMIN_MENU_ITEMS = [
    { key: "1", icon: <HomeOutlined />, label: "Home", href: "/dashboard/home" },
    { key: "2", icon: <TeamOutlined />, label: "Users", href: "/dashboard/users" },
    { key: "3", icon: <BookOutlined />, label: "Courses", href: "/dashboard/cources" },
    { key: "4", icon: <FileDoneOutlined />, label: "Assessments", href: "/dashboard/assessments" },
    { key: "5", icon: <FileTextOutlined />, label: "Certificates", href: "/dashboard/certificates" },
    { key: "6", icon: <TrophyOutlined />, label: "Badges", href: "/dashboard/badges" },
    { key: "7", icon: <UsergroupAddOutlined />, label: "Attendance", href: "/dashboard/attendance" },
    { key: "8", icon: <DollarOutlined />, label: "Payments", href: "/dashboard/payments" },
    { key: "9", icon: <SnippetsOutlined />, label: "Notes", href: "/dashboard/notes" },
    { key: "10", icon: <StarOutlined />, label: "Wish List", href: "/dashboard/wishlist" },
    { key: "11", icon: <BankOutlined />, label: "Centers", href: "/dashboard/centers" },
]

const ADMIN_MENU_ITEMS = [
    { key: "1", icon: <HomeOutlined />, label: "Home", href: "/dashboard/home" },
    { key: "2", icon: <TeamOutlined />, label: "Users", href: "/dashboard/users" },
    { key: "3", icon: <BookOutlined />, label: "Courses", href: "/dashboard/cources" },
    { key: "4", icon: <FileDoneOutlined />, label: "Assessments", href: "/dashboard/assessments" },
    { key: "5", icon: <FileTextOutlined />, label: "Certificates", href: "/dashboard/certificates" },
    { key: "6", icon: <TrophyOutlined />, label: "Badges", href: "/dashboard/badges" },
    { key: "7", icon: <UsergroupAddOutlined />, label: "Attendance", href: "/dashboard/attendance" },
    { key: "8", icon: <DollarOutlined />, label: "Payments", href: "/dashboard/payments" },
    { key: "9", icon: <SnippetsOutlined />, label: "Notes", href: "/dashboard/notes" },
    { key: "10", icon: <StarOutlined />, label: "Wish List", href: "/dashboard/wishlist" },
]

const STUDENT_MENU_ITEMS = [
    { key: "1", icon: <HomeOutlined />, label: "Home", href: "/dashboard/home" },
    { key: "3", icon: <BookOutlined />, label: "Courses", href: "/dashboard/cources" },
    { key: "8", icon: <UsergroupAddOutlined />, label: "My Cources", href: "/dashboard/mycources" },
    { key: "4", icon: <FileDoneOutlined />, label: "Assessments", href: "/dashboard/assessments" },
    { key: "5", icon: <FileTextOutlined />, label: "Certificates", href: "/dashboard/certificates" },
    { key: "6", icon: <TrophyOutlined />, label: "Badges", href: "/dashboard/badges" },
    { key: "9", icon: <StarOutlined />, label: "Wish List", href: "/dashboard/wishlist" },
]

const COORDINATOR_MENU_ITEMS = [
    { key: "1", icon: <HomeOutlined />, label: "Home", href: "/dashboard/home" },
    { key: "3", icon: <BookOutlined />, label: "Courses", href: "/dashboard/cources" },
    { key: "8", icon: <DollarOutlined />, label: "Payments", href: "/dashboard/payments" },
]

export {
    SUPER_ADMIN_MENU_ITEMS,
    ADMIN_MENU_ITEMS,
    STUDENT_MENU_ITEMS,
    COORDINATOR_MENU_ITEMS,
}
